import {
    STRIPE_COLLECT_PAYMENT_URL,
    STRIPE_PROCESS_PAYMENT_URL,
    REGISTER_STRIPE_TERMINAL_URL,
    CANCEL_STRIPE_TERMINAL_URL,
} from 'shared/utils/Constants';

import { get, post } from 'shared/services/ApiService';

export default class StripeService {
    async collectPayment(accountId, params) {
        return await post(STRIPE_COLLECT_PAYMENT_URL(accountId), params);
    }

    async processPayment(accountId, params) {
        return await post(STRIPE_PROCESS_PAYMENT_URL(accountId), params);
    }

    async registerStripeReader(accountId, params) {
        return await post(REGISTER_STRIPE_TERMINAL_URL(accountId), params);
    }

    async cancelStripeReader(accountId, params) {
        return await post(CANCEL_STRIPE_TERMINAL_URL(accountId), params);
    }
}